import { cva } from "@-/com.npmjs.cva";
import { cn } from "@-/com.npmjs.cn";
import { Platform } from "@-/com.npmjs.react-native";

// All neutral controls use the shared accent gray for press and selected feedback.
const PRESS_OVERRIDE = Platform.select({
  default: "active:bg-accent",
  web: "active:bg-accent hover:bg-accent",
});

/**
 * Small opaque floating **circle** button holding a single icon — an opaque surface + border so
 * list/content scrolling underneath doesn't bleed through the circle. Built on top of the `outline`
 * {@link buttonVariants} `size="fill"` button.
 *
 * The `active` variant swaps in a darker `muted` fill and an inner border so a toggled-on state
 * reads at a glance (used by the nav-header push buttons); the default `false` pins a solid
 * `background` surface.
 */
export const iconButtonVariants = cva({
  base: cn(
    // `dark:bg-background` pins a solid surface over the `outline` variant's translucent
    // `dark:bg-input/30`, which the unprefixed `bg-background` can't override (different
    // tailwind-merge group) — without it list content bleeds through the circle in dark mode.
    // oxlint-disable-next-line tailwindcss/no-contradicting-variants -- pins a solid dark surface over the variant's translucent default
    "size-7 rounded-full border-border/60 shadow-none",
    PRESS_OVERRIDE,
  ),
  defaultVariants: {
    active: false,
  },
  variants: {
    active: {
      // oxlint-disable-next-line tailwindcss/no-contradicting-variants -- pins a solid dark surface over the variant's translucent default
      false: "bg-background dark:bg-background",
      true: "border-foreground/15 bg-accent",
    },
  },
});
